<template>
	<div class="app-basic-text-field">
		<v-text-field :class="{ small: small, naked: naked }" v-bind="$attrs" v-on="$listeners" outlined hide-details dense> </v-text-field>
	</div>
</template>

<script>
export default {
	name: 'BasicTextField',
	props: {
		small: { type: Boolean },
		naked: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.app-basic-text-field {
	&::v-deep {
		.v-text-field--outlined fieldset {
			border-width: 1px;
			transition: all 0.2s;
		}
		.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) fieldset {
			border-color: var(--seconday-border-color) !important;
		}
		.v-text-field .v-label {
			color: #c0c3c9 !important;
			font-size: 14px;
		}
		.v-text-field.v-input--is-focused fieldset {
			border: 1px solid var(--primary-border-color) !important;
		}
	}
	&[disabled='disabled'] {
		&::v-deep(fieldset) {
			background-color: #dfe4ef4d;
		}
	}
	.small {
		&::v-deep {
			&.v-text-field .v-input__control .v-input__slot {
				min-height: auto !important;
				display: flex !important;
				align-items: center !important;
			}
			&.v-text-field .v-label {
				top: 50%;
				transform: translateY(-50%);
			}
			&.v-text-field--enclosed .v-input__prepend-inner {
				margin-top: 15px !important;
			}
			&.v-text-field--enclosed .v-input__append-inner,
			&.v-text-field--enclosed .v-input__clear {
				margin-top: 3px !important;
			}
			&.v-text-field {
				border-radius: 5px;
				font-size: 14px;
				font-weight: 400;
				line-height: 40px;
			}
		}
	}
	.naked {
		border-style: none !important;

		::v-deep(fieldset) {
			display: none;
		}
	}
}
</style>
